"use client";

import { useEffect } from "react";
import { LanguageProvider } from "./components/context/LanguageContext";
import { ThemeProvider } from "./context/ThemeContext";
import "./globals.css";
import SeenPopup from "./components/SeenPopup";
import { setVisitorCookie } from "./utils/cookies";
import { DevToolsBlocker } from "./components /DevToolsBlocker";
import Navbar from "./components/Homapage/Navbar";

export default function RootLayout({ children }: { children: React.ReactNode }) {
  useEffect(() => {
    setVisitorCookie(); // run once per visitor
  }, []);

  return (
    <html lang="fr" suppressHydrationWarning>
       <body
        className="transition-colors duration-300 bg-white text-gray-900 dark:bg-gray-900 dark:text-gray-100"
        suppressHydrationWarning
      >
        <ThemeProvider>
          <LanguageProvider>
            
            <SeenPopup />
            {/*<DevToolsBlocker />*/}
            {children}
          </LanguageProvider>
        </ThemeProvider>
      </body>
    </html>
  );
}









/*
"use client";

import { useEffect } from "react";
import { LanguageProvider } from "./components/context/LanguageContext";
import { ThemeProvider } from "./context/ThemeContext";
import "./globals.css";
import SeenPopup from "./components/SeenPopup";
import { setVisitorCookie } from "./utils/cookies";
import { DevToolsBlocker } from "./components /DevToolsBlocker";
 
export default function RootLayout({ children }: { children: React.ReactNode }) {
  useEffect(() => {
    setVisitorCookie(); // run once per visitor
  }, []);

  return (
    <html lang="en" suppressHydrationWarning>
 <body className="transition-colors duration-300 bg-white text-gray-900 dark:bg-gray-900 dark:text-gray-100">
         
         <ThemeProvider>
          <LanguageProvider>
            
                        <SeenPopup />
<DevToolsBlocker /> 
            
            {children}</LanguageProvider>
        </ThemeProvider>
      </body>
    </html>
  );
}
*/